import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import Skeleton from 'react-loading-skeleton'

import { getLoadingPodcasts, getPodcasts } from 'modules/home/HomeSelector'
import { createPlaceholderKey } from 'utils'
import styles from 'components/Curriculum/Curriculum.module.sass'

const Podcast = () => {
  const loading = useSelector(getLoadingPodcasts)
  const podcast = useSelector(getPodcasts)

  const loadingKeys = useMemo(
    () => Array.from({ length: 5 }, () => createPlaceholderKey()),
    []
  )

  return (
    <div className={styles.container}>
      <h2 className={styles.h2}>Subscribe to Our Podcasts</h2>
      {loading
        ? loadingKeys.map(key => (
            <div style={{ marginBottom: '25px' }} key={key}>
              <Skeleton count={2} height={15} />
            </div>
          ))
        : podcast?.map(({ channel, distributions }) => (
            <div key={channel} className={styles.span}>
              <p className={styles.menuText}>{channel}</p>
              {distributions
                .map(({ name, url }) => (
                  <a
                    key={name}
                    href={url}
                    target="_blank"
                    rel="noreferrer"
                    className={styles.link}
                  >
                    {name}
                  </a>
                ))
                .reduce((prev, curr) => [prev, ' | ', curr])}
            </div>
          ))}
    </div>
  )
}

Podcast.propTypes = {}

export default Podcast
